<lui-selector [value]="value" (valueChange)="onValueChange($event)">
  <mat-form-field>
    <input
      matInput
      [placeholder]="placeholder"
      (keyup)="onSearch(searchInput.value)"
    />
    <mat-icon matSuffix svgIcon="search" class="text-grayMedium"></mat-icon>
  </mat-form-field>

  <mat-option *ngFor="let item of filteredItems$ | async" [value]="item.id">
    <div class="hstack gap-1 justify-content-center">
      <lui-avatar [size]="40" [color]="item.label | stringColor">
        <mat-icon *ngIf="item.icon" [svgIcon]="item.icon"></mat-icon>
        <span *ngIf="!item.icon">{{ item.label | initials }}</span>
      </lui-avatar>
      {{ item.label }}
    </div>
  </mat-option>
</lui-selector>
